import axios from "axios";

//for local
//const API_BASE_URL = 'http://localhost:5000';
//for production
const API_BASE_URL = 'https://reseller-portal-web-apis.azurewebsites.net'
//for development
//const API_BASE_URL = 'https://reseller-portal-web-apis-development.azurewebsites.net'

class QuickBooksService {
  constructor() {
    this.api = axios.create({
      baseURL: API_BASE_URL,
    });

    this.api.interceptors.request.use(
      (config) => {
        const token = this.getAuthToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  }

  getAuthToken() {
    return localStorage.getItem("token") || sessionStorage.getItem("token");
  }

async createInvoice(orderData) {
  try {
    console.log("🔄 QuickBooks Service - Creating invoice with payment terms:", orderData.payment_terms);
    console.log("📦 Order type:", orderData.is_new_purchase ? "NEW PURCHASE" : "RENEWAL");
    console.log("📧 Email details from frontend:", {
      customer_email: orderData.customer_email,
      partner_email: orderData.partner_email,
      billing_email: orderData.billing_email
    });
    
    
    // Ensure email fields are properly structured for QuickBooks
    const quickbooksPayload = {
      ...orderData,
      // Make sure we're sending the correct email structure
      customer_email: orderData.customer_email, // End user
      partner_email: orderData.partner_email,   // Reseller
      billing_email: orderData.billing_email || orderData.customer_email // Default to customer email
    };
    
   
    
    const quickbooksResponse = await this.api.post('/quickbooks/create-invoice', quickbooksPayload);
    
    
    // ✅ ALWAYS CREATE/UPDATE DATABASE ORDER
    try {
      if (orderData.is_new_purchase === false) {
 
        const orderResponse = await this.api.post('/client-orders/renew', {
          ...orderData,
          // Ensure we have the original subscription number for renewals
          original_subscription_number: orderData.original_subscription_number || orderData.subscription_number?.replace('RENEW-', '').split('-')[0],
          // Include tax information from QuickBooks response
          tax_amount: quickbooksResponse.data.invoice_data?.amounts?.tax_amount,
          total_amount_with_tax: quickbooksResponse.data.invoice_data?.amounts?.total_due
        });
        
      } else {
        // NEW PURCHASE: Use the regular endpoint
        
        const orderResponse = await this.api.post('/client-orders', {
          ...orderData,
          // Include tax information from QuickBooks response
          tax_amount: quickbooksResponse.data.invoice_data?.amounts?.tax_amount,
          total_amount_with_tax: quickbooksResponse.data.invoice_data?.amounts?.total_due
        });
        
      }
    } catch (orderError) {
      console.error("❌ Error creating database order:", orderError.response?.data || orderError.message);
      // Don't fail the whole process if database update fails
      // Just log the error but continue with the QuickBooks response
    }
    
    // ✅ Return QuickBooks response for both immediate and net terms
    return quickbooksResponse.data;
    
  } catch (error) {
    console.error('❌ Error creating invoice:', error.response?.data || error.message);
    throw error;
  }
}

  async checkConnection() {
    try {
      const response = await this.api.get("/quickbooks/check-connection");
      return response.data;
    } catch (error) {
      return { success: false, connected: false };
    }
  }

  async checkPaymentStatus(invoiceId) {
    try {
      const response = await this.api.get(
        `/quickbooks/check-payment-status/${invoiceId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error checking payment status:", error);
      throw error;
    }
  }
}

export default new QuickBooksService();